import { render, staticRenderFns } from "./SubscribeBasicInformation.vue?vue&type=template&id=d2b9c224&scoped=true"
import script from "./SubscribeBasicInformation.vue?vue&type=script&lang=js"
export * from "./SubscribeBasicInformation.vue?vue&type=script&lang=js"
import style0 from "./SubscribeBasicInformation.vue?vue&type=style&index=0&id=d2b9c224&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b9c224",
  null
  
)

export default component.exports